import { ReactNode } from 'react'
import { Link, useLocation } from 'react-router-dom'

interface AdminLayoutProps {
  children: ReactNode
}

const adminLinks = [
  { label: 'Overview', to: '/admin' },
  { label: 'Categories', to: '/admin/categories' },
]

export default function AdminLayout({ children }: AdminLayoutProps) {
  const location = useLocation()

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Admin breadcrumb */}
      <div className="flex items-center gap-2 text-sm text-[#718096] mb-6">
        <Link to="/dashboard" className="hover:text-[#1B365D]">Dashboard</Link>
        <span>/</span>
        <span className="text-[#1B365D] font-medium">Admin</span>
      </div>

      {/* Admin sub-navigation tabs */}
      <div className="flex gap-6 border-b border-[#E2E8F0] mb-8">
        {adminLinks.map(link => {
          const isActive = location.pathname === link.to
          return (
            <Link
              key={link.to}
              to={link.to}
              className={`pb-3 text-[14px] font-medium border-b-2 transition-colors ${
                isActive
                  ? 'border-[#1B365D] text-[#1B365D]'
                  : 'border-transparent text-[#4A5568] hover:text-[#1B365D]'
              }`}
            >
              {link.label}
            </Link>
          )
        })}
      </div>

      {children}
    </div>
  )
}
